import React, { useState } from 'react';
import UserListView from './UserListView';
import { mockUsers } from '../../data/mockUsers';

const Conversions = () => {
  const [users, setUsers] = useState(
    mockUsers.filter(user => user.journeyStage === 'paid' || user.journeyStage === 'paywall')
  );

  const handleFilter = (filter) => {
    // In a real app, this would be an API call
    switch (filter) {
      case 'paid':
        setUsers(mockUsers.filter(user => user.journeyStage === 'paid'));
        break;
      case 'paywall':
        setUsers(mockUsers.filter(user => user.journeyStage === 'paywall'));
        break;
      default:
        setUsers(mockUsers.filter(user => 
          user.journeyStage === 'paid' || user.journeyStage === 'paywall'
        ));
    }
  };

  const handleSearch = (query) => {
    if (!query) {
      setUsers(mockUsers.filter(user => 
        user.journeyStage === 'paid' || user.journeyStage === 'paywall'
      ));
      return;
    }
    const searchTerm = query.toLowerCase();
    setUsers(mockUsers.filter(user => 
      (user.journeyStage === 'paid' || user.journeyStage === 'paywall') &&
      (user.name.toLowerCase().includes(searchTerm) ||
       user.email.toLowerCase().includes(searchTerm) ||
       user.tags.some(tag => tag.toLowerCase().includes(searchTerm)))
    ));
  };

  const handleSort = (column, direction) => {
    const sortedUsers = [...users].sort((a, b) => {
      let comparison = 0;
      switch (column) {
        case 'name':
          comparison = a.name.localeCompare(b.name);
          break;
        case 'valueScore':
          comparison = a.valueScore - b.valueScore;
          break;
        case 'resumesCreated':
          comparison = a.resumesCreated - b.resumesCreated;
          break;
        case 'journeyStage':
          comparison = a.journeyStage.localeCompare(b.journeyStage);
          break;
        default:
          comparison = 0;
      }
      return direction === 'asc' ? comparison : -comparison;
    });
    setUsers(sortedUsers);
  };

  const handleSendEmail = () => {
    // In a real app, this would open an email modal or make an API call
    console.log('Sending email to selected users');
  };

  const handleAddTags = () => {
    // In a real app, this would open a tag modal or make an API call
    console.log('Adding tags to selected users');
  };

  const handleExport = (userIds) => {
    // In a real app, this would generate and download a CSV
    console.log('Exporting users:', userIds);
  };

  const paidUsers = users.filter(user => user.journeyStage === 'paid').length;
  const paywallUsers = users.filter(user => user.journeyStage === 'paywall').length;
  const conversionRate = ((paidUsers / (paidUsers + paywallUsers)) * 100).toFixed(1);

  return (
    <UserListView
      title="Conversions"
      description={`${paidUsers} paid users, ${paywallUsers} at paywall (${conversionRate}% conversion rate)`}
      users={users}
      onFilter={handleFilter}
      onSearch={handleSearch}
      onSort={handleSort}
      onSendEmail={handleSendEmail}
      onAddTags={handleAddTags}
      onExport={handleExport}
    />
  );
};

export default Conversions; 